<div class="library library-home notice-bg-bg">
  <div class="flex flex-col md:flex-row">
    <div class="content-block dark-theme library__header primary-bg md:w-1/3">
      <app-library-filters [isSplitScreen]="true" [showAdvancedFilteringOptions]="false" />
    </div>
    <div class="library__content library-home__content content-block md:w-2/3">
      <div class="notice center" i18n>
        Explore suggested curricula for the given grade levels. Check out our
        <a routerLink="/curriculum">full library</a> to explore in more depth.
      </div>
      <app-official-library [isSplitScreen]="true" />
    </div>
  </div>
</div>
